<template>
  <div class="og-home-screenshots" aria-label="OG WhatsApp interface screenshots">
    <div ref="swiperEl" class="swiper-container og-home-screenshots__swiper">
      <div class="swiper-wrapper">
        <div v-for="(slide, i) in slides" :key="i" class="swiper-slide">
          <figure class="og-home-screenshots__figure">
            <img
              :src="slide.src"
              :alt="slide.alt"
              class="og-home-screenshots__img"
              :loading="i === 0 ? 'eager' : 'lazy'"
              width="390"
              height="844"
            />
          </figure>
        </div>
      </div>
      <div ref="paginationEl" class="swiper-pagination og-home-screenshots__pagination" />
      <div ref="prevEl" class="swiper-button-prev og-home-screenshots__nav og-home-screenshots__nav--prev" />
      <div ref="nextEl" class="swiper-button-next og-home-screenshots__nav og-home-screenshots__nav--next" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/js/swiper.esm.bundle.js';
import 'swiper/css/swiper.css';

export default {
  name: 'OgHomeScreenshots',
  data() {
    return {
      swiper: null,
      slides: [
        {
          src: require('@/assets/og-screens/og-screen-1.png'),
          alt: 'OG WhatsApp Privacy screen with Ghost Mode, hide online, and anti-delete messages',
        },
        {
          src: require('@/assets/og-screens/og-screen-2.png'),
          alt: 'OG WhatsApp chats menu with Message Scheduler, Auto Reply, and mass sender',
        },
        {
          src: require('@/assets/og-screens/og-screen-3.png'),
          alt: 'OG WhatsApp header customization options',
        },
        {
          src: require('@/assets/og-screens/og-screen-4.png'),
          alt: 'OG WhatsApp Settings in dark mode',
        },
        {
          src: require('@/assets/og-screens/og-screen-5.png'),
          alt: 'OG WhatsApp Privacy screen with last seen and read receipts',
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$refs.swiperEl) return;
      this.swiper = new Swiper(this.$refs.swiperEl, {
        loop: true,
        speed: 400,
        spaceBetween: 12,
        centeredSlides: true,
        slidesPerView: 1,
        breakpoints: {
          640: {
            slidesPerView: 1.15,
            spaceBetween: 16,
          },
        },
        autoplay: {
          delay: 4800,
          disableOnInteraction: false,
        },
        pagination: {
          el: this.$refs.paginationEl,
          clickable: true,
        },
        navigation: {
          prevEl: this.$refs.prevEl,
          nextEl: this.$refs.nextEl,
        },
      });
    });
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.og-home-screenshots {
  margin: 0.75rem 0 2rem;
  max-width: 100%;
}

.og-home-screenshots__swiper {
  position: relative;
  padding: 0 0 44px;
  overflow: hidden;
}

.og-home-screenshots__figure {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.og-home-screenshots__img {
  display: block;
  width: 100%;
  max-width: 360px;
  height: auto;
  max-height: min(72vh, 720px);
  object-fit: contain;
  border-radius: 14px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);
  background: #0f172a;
}

/* Swiper 5 导航色与站点绿一致 */
.og-home-screenshots ::v-deep .swiper-button-prev,
.og-home-screenshots ::v-deep .swiper-button-next {
  color: #204f46;
  width: 40px;
  height: 40px;
  margin-top: -28px;
}

.og-home-screenshots ::v-deep .swiper-button-prev::after,
.og-home-screenshots ::v-deep .swiper-button-next::after {
  font-size: 18px;
  font-weight: 700;
}

.og-home-screenshots ::v-deep .swiper-pagination-bullet-active {
  background: #204f46;
}

@media (max-width: 520px) {
  .og-home-screenshots ::v-deep .swiper-button-prev,
  .og-home-screenshots ::v-deep .swiper-button-next {
    display: none;
  }
}
</style>
